module.exports = __webpack_public_path__ + "img/火币中国大图.250345fe.png";